import { Select } from '@mantine/core';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router';

const PageFilter = ({ options, placeholder, queryKey, overwritePage = true }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const selectedValue = queryString.parse(location.search)?.[queryKey];

  const handleChange = (value) => {
    const newFilter = { ...queryString.parse(location.search) };

    if (newFilter.page && overwritePage) {
      newFilter.page = 1;
    }

    if (value) {
      newFilter[queryKey] = value;
    } else {
      delete newFilter[queryKey];
    }

    navigate({ search: queryString.stringify({ ...newFilter }) });
  };

  return (
    <Select
      clearable
      searchable={true}
      initialValue={selectedValue}
      placeholder={placeholder}
      onChange={handleChange}
      data={options}
    />
  );
};

export default PageFilter;
